import { render, staticRenderFns } from "./_purchaser_li.vue?vue&type=template&id=6de29fbf&scoped=true&"
import script from "./_purchaser_li.vue?vue&type=script&lang=js&"
export * from "./_purchaser_li.vue?vue&type=script&lang=js&"
import style0 from "./_purchaser_li.vue?vue&type=style&index=0&id=6de29fbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de29fbf",
  null
  
)

export default component.exports